// expandableMenus.js
import AccessibleSubmenu from 'accessible-submenu';
import { each, selectAll } from './utils/dom';

// Find all qualifying "menus" which in our case will be a list item:
each(selectAll('.js-expandable'), (menuItem) => {
  new AccessibleSubmenu(menuItem, {
    // whether or not to close on tab out
    closeOnTabOut: false,
  }); // eslint-disable-line no-new
});

each(selectAll(".js-expand-menu"), (menuItem) => {
  menuItem.addEventListener('click', (event) => {
    event.preventDefault();
    const expandButton = event.srcElement.nextElementSibling;
    if (expandButton && expandButton.classList.contains("js-submenu-expand")) {
      expandButton.click();
    }
  });
});

each(selectAll(".js-submenu-collapse"), (menuItem) => {
  menuItem.addEventListener('click', (event) => {
    event.preventDefault();
    const subMenu = event.srcElement.closest(".js-submenu");
    if (subMenu) {
      const expandButton = subMenu.previousElementSibling;
      if (expandButton && expandButton.classList.contains("js-submenu-expand")) {
        expandButton.click();
      }
    }
  });
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/expandableMenus.js